import React, { Component, Fragment } from 'react';
import API from '../../api/api';
import './liveActivity.less';
import moment from 'moment';
import zhCN from 'antd/es/locale/zh_CN';
import { Tabs, Table, Button, Input, DatePicker, Select, Modal, message, InputNumber, Popconfirm, ConfigProvider } from 'antd';
import { thisExpression } from '@babel/types';
import TextArea from 'antd/lib/input/TextArea';
const { TabPane } = Tabs;
const { RangePicker } = DatePicker;
const { Option } = Select;
var uploader = require('../../thirdTool/alioss/upload.js');
class LiveActivity extends Component {
    constructor(props) {
        super(props);
    }
    state = {
        activityList: [
            // {
            //     playId: '8',//推广Id
            //     playType: '1',//活动类型
            //     activityId: '111',//活动Id
            //     actName: '花湖',//活动名称
            //     liveType: '1',//推广模块（1公众圈直播，2秀客直播）
            //     targetType: '1',//推广范围（ 1指定公众圈，2指定主播）
            //     targetValue: '1123',//公众圈Id       
            //     startTime: '2020-4-4',
            //     endTime: '2020-6-4',
            //     status: '0',//（0 未开始，1进行中 ，2 已结束）
            // },
        ],
        columnsOfLive: [//直播推广活动列表表头
            {
                title: '推广ID',
                dataIndex: 'id',
                key: 'd',
            },
            {
                title: '活动类型',
                dataIndex: 'playType',
                key: 'playType',
                render: (data) => (
                    <span>{new Map([['1', '抽奖'], ['3', '礼包'], ['4', '寻宝'], ['100', '组局'], ['201', '领券']]).get(data + '')}</span>
                ),
            },
            {
                title: '活动ID',
                dataIndex: 'playId',
                key: 'playId',
            },
            {
                title: '活动名称',
                dataIndex: 'actName',
                key: 'actName',
            },
            {
                title: '推广模块',
                dataIndex: 'liveType',
                key: 'liveType',
                render: (data) => (
                    <span>
                        {
                            data == 1 ? '公众圈直播' : '秀客直播'
                        }
                    </span>
                ),
            },
            {
                title: '推广范围',
                key: 'targetType',
                render: (data) => (
                    <span className={`${data.targetType == 1 || data.targetType == 2 ? 'canClick' : ''}`} onClick={this.showInfoModal.bind(this, data)}>
                        {
                            new Map([['1', '指定公众圈'], ['2', '指定主播'], ['0', '所有']]).get(data.targetType + '')
                        }
                    </span>
                ),
            },
            {
                title: '推广开始时间',
                dataIndex: 'startTime',
                key: 'startTime',
                render: (data) => (
                    <span>{moment(data * 1000).format('YYYY-MM-DD HH:mm:ss')}</span>
                )
            },
            {
                title: '推广结束时间',
                dataIndex: 'endTime',
                key: 'endTime',
                render: (data) => (
                    <span>{moment(data * 1000).format('YYYY-MM-DD HH:mm:ss')}</span>
                )
            },
            {
                title: '推广状态',
                dataIndex: 'status',
                key: 'status',
                render: (data) => (
                    <span>
                        {
                            data == 0 ? '未开始' : data == 1 ? '进行中' : '已结束'
                        }
                    </span>
                ),
            },
            {
                title: '编辑',
                key: 'edit',
                render: (data) => (
                    <div className="operateBtnBlock">{
                        (data.status == 0 || data.status == 1) ?
                        <a onClick={this.editActivity.bind(this, data.id)}>编辑</a>:
                        <span className="hasFreeze">编辑</span>
                    }
                        
                    </div>
                ),
            },
            {
                title: '结束',
                key: 'endStatus',
                render: (data) => (
                    <div className="operateBtnBlock">
                        {
                            (data.status == 0 || data.status == 1) ?
                                <Popconfirm title="确定结束该推广活动吗"
                                    onConfirm={this.finishActivity.bind(this, data.id)}
                                    okText="确定"
                                    cancelText="取消"
                                >
                                    <Button key={'finishBtn' + data.playId} type="danger" className="finishBtn">结束</Button>
                                </Popconfirm>
                                : (data.status == 2 ? <span className="hasFreeze">已结束</span> : '')
                        }
                    </div>
                ),
            },
        ],
        columnsOfCircle: [
            {
                title: '公众圈ID',
                dataIndex: 'infoId',
                key: 'infoId',
            },
            {
                title: '公众圈名称',
                dataIndex: 'infoName',
                key: 'infoName',
            }
        ],
        columnsOfUser: [
            {
                title: '用户ID',
                dataIndex: 'infoId',
                key: 'infoId',
            },
            {
                title: '用户昵称',
                dataIndex: 'infoName',
                key: 'infoName',
            }
        ],
        searchCondition: {//搜索条件
            actName: '',
        },
        infoModal: {
            isCircleInfo: true,
            infoList: [],
            isCityCircle: false,
            show: false
        },
        hasClicked: false,
        addOrEditModal: {
            isAdd: true,
            show: false,
            playType: '1',// 
            playId: '',
            liveType: '1',
            targetType: '1',
            targetValue: '',
            image: '',
            cityCircle: 0
        }
    }
    componentDidMount() {
        this.getListData()
    }
    componentWillReceiveProps() {
        this.getListData()
    }
    getListData() {
        const {
            searchCondition
        } = this.state;
        this.getPlayList(searchCondition)
    }
    showInfoModal(data) {
        if (data.targetType != 1 && data.targetType != 2) {
            return;
        }
        this.getPlayDetail({ id: data.id },'view')
    }
    InputItemChange(type, e) {
        let value = e.target.value.trim();//不能缺少的声明 eval表达式需要用到value
        console.log(value)
        const { searchCondition, addOrEditModal } = this.state;
        switch (type) {
            case 'actName':
                searchCondition.actName = value;
                break;
            case 'playId':
                addOrEditModal.playId = value;
                break;
            case 'targetValue':
                addOrEditModal.targetValue = value;
                break;
        }
        this.setState({
            searchCondition,
            addOrEditModal
        })
    }
    onSelectChange(type, value) {
        const { addOrEditModal } = this.state;
        console.log(value)
        switch (type) {
            case 'playType':
                addOrEditModal.playType = value
                break;
            case 'liveType':
                addOrEditModal.liveType = value
                if (value == 1 && addOrEditModal.targetType == 2) {
                    addOrEditModal.targetType = 1;
                }
                break;
            case 'targetType':
                addOrEditModal.targetType = value
                break;
        }
        this.setState({ addOrEditModal })
    }
    modalCancel(type) {
        const { infoModal, addOrEditModal } = this.state;
        switch (type) {
            case 'info':
                infoModal.show = false;
                break;
            case 'addOrEdit':
                addOrEditModal.show = false;
                break;
        }
        this.setState({
            infoModal,
            addOrEditModal
        })
    }
    finishActivity(id) {
        let param = {
            action: 2,
            id
        }
        this.addPlay(param);
    }
    async getPlayDetail(param, type) {
        let result = await API.playDetail(param);
        let { addOrEditModal,infoModal} = this.state;
        if (!result) return;
        if (result.status === '1') {
            let data = result.data;
            if (type == 'edit') {
                let defaultMoment = [moment(data.startTime * 1000), moment(data.endTime * 1000)];
                addOrEditModal =
                {
                    id: data.id,
                    show: true,
                    isAdd: false,
                    playType: data.playType ? data.playType.toString() : 1,// 
                    playId: data.playId ? data.playId.toString() : '',
                    liveType: data.liveType ? data.liveType.toString() : 1,
                    targetType: data.targetType ? data.targetType.toString() : 1,
                    targetValue: data.targetValue ? data.targetValue.toString() : '',
                    image: data.image,
                    cityCircle: data.cityCircle == false ? 0 : 1,
                    defaultMoment: defaultMoment,
                    startTime: data.startTime,
                    endTime: data.endTime
                }
                this.setState({
                    addOrEditModal
                }, () => {
                    setTimeout(() => {
                        let item = {
                            buttonID: 'chooseActivityPic', picType: 'activityPic', extensions: 'jpg,png,bmp,jpeg'
                        }
                        let obj = (new Function('return' + data.image))()
                        document.getElementById(item.buttonID).style.backgroundImage = 'url(' + obj.picture + ')';
                        this.initUpload(item)
                    })
                })
            }else if(type=='view'){
                infoModal.show=true;
                if (data.targetType == 2) {
                    infoModal.isCircleInfo = false;
                }else{
                    infoModal.isCircleInfo=true;
                }
                if(data.extraDOS){
                    infoModal.infoList=data.extraDOS.map((item)=>{
                        return {
                            infoId:data.targetType == 2?item.userId:item.circleId,
                            infoName:data.targetType == 2?item.userName:item.circleName,
                        }
                    })
                }
                infoModal.cityCircle = data.cityCircle==true?1:0
                this.setState({
                    infoModal
                })
            }
        }
        else {
            message.error(result.msg);
        }
    }
    editActivity(id) {
        console.log(id)
        this.getPlayDetail({ id },'edit');
    }
    addActivity() {
        let { addOrEditModal } = this.state;
        addOrEditModal= {
            isAdd: true,
            show: true,
            playType: '1',// 
            playId: '',
            liveType: '1',
            targetType: '1',
            targetValue: '',
            image: '',
            cityCircle: 0
        }
        this.setState({
            addOrEditModal
        }, () => {
            this.initUpload({
                buttonID: 'chooseActivityPic', picType: 'activityPic', extensions: 'jpg,png,bmp,jpeg'
            })
        })
    }
    async getPictureInfo(url) { // 获取图片信息
        let result = await API.syncPic({ url: url });
        if (!result) return;
        if (result) {
            let picObj = {
                picture: url,
                width: result.ImageWidth.value,
                height: result.ImageHeight.value
            }
            return picObj;
        }
        else {
            message.error(result.msg);
        }
    };
    onDateChange = (date) => { //筛选条件 ：时间范围
        const {
            addOrEditModal
        } = this.state;
        let startTime = '', endTime = '';
        if (date.length == 0) {
            startTime = '';
            endTime = '';
        } else {
            startTime = Math.floor(date[0].valueOf() / 1000);
            endTime = Math.floor(date[1].valueOf() / 1000);
        }
        addOrEditModal.startTime = startTime;
        addOrEditModal.endTime = endTime;
        this.setState({
            addOrEditModal
        });
    }
    async addPlay(params) { // 添加推广活动
        let result = await API.playAdd(params);
        if (!result) return;
        if (result.status === '1') {
            message.success('操作成功')
            this.getListData();
            let { addOrEditModal } = this.state;
            addOrEditModal = {
                isAdd: true,
                show: false,
                playType: '1',// 
                playId: '',
                liveType: '1',
                targetType: '1',
                targetValue: '',
                image: '',
                cityCircle: 0
            }
            this.setState({
                addOrEditModal
            })
        }
        else {
            message.error(result.msg);
        }
    };
    async getPlayList(params) { // 推广活动列表
        let result = await API.playList(params);
        if (!result) return;
        if (result.status === '1') {
            this.setState({
                activityList: result.data.playList
            })
        }
        else {
            message.error(result.msg);
        }
    };
    addOrEdit() {
        const { addOrEditModal } = this.state;
        let param = {
            action: 0,
            playId: addOrEditModal.playId,
            playType: addOrEditModal.playType,
            image: JSON.stringify(addOrEditModal.image),
            liveType: addOrEditModal.liveType,
            targetType: addOrEditModal.targetType,
            cityCircle: addOrEditModal.cityCircle,
            startTime: addOrEditModal.startTime,
            endTime: addOrEditModal.endTime,
            targetValue: addOrEditModal.targetValue
        }
        if (addOrEditModal.id) {
            param.action = 1;
            param.id = addOrEditModal.id;
            param.image = addOrEditModal.image;
        }
        this.setState({
            hasClicked: true
        }, () => {
            setTimeout(() => {
                if (document.querySelectorAll('.formItemError').length > 0) {
                    return
                }
                else {
                    this.addPlay(param)
                }
            })
        })
    }
    initUpload(item) { //初始化视频上传
        let self = this;
        setTimeout(() => {
            if (document.getElementById(item.buttonID)) {
                let { addOrEditModal } = self.state;
                uploader({
                    serverUrl: '/promotion/oss/policy',
                    upload_button: item.buttonID,
                    multi: false,
                    extensions: item.extensions,
                    added: function () {
                    },
                    success: function (file_url, file) {
                        let picObj;
                        self.getPictureInfo(file_url).then(obj => {
                            if (item.picType == 'activityPic') {
                                addOrEditModal.image = obj
                                self.setState({
                                    addOrEditModal
                                })
                            }
                            document.getElementById(item.buttonID).style.backgroundImage = 'url(' + obj.picture + ')';
                        });
                    },
                    error: function (msg) {
                        message.error(msg)
                    }
                })
            }
        }, 100)
    }
    chooseCityCircle() {
        const { addOrEditModal } = this.state;
        addOrEditModal.cityCircle = !addOrEditModal.cityCircle;
        this.setState({ addOrEditModal })
    }
    render() {
        const {
            columnsOfLive,
            activityList,
            infoModal,
            columnsOfUser,
            columnsOfCircle,
            hasClicked,
            addOrEditModal
        } = this.state;
        return (
            <ConfigProvider locale={zhCN}>
                <Fragment>
                    <div className="searchPane">
                        <div className="leftCondition">
                            <div className="inputPane">
                                <Input onChange={this.InputItemChange.bind(this, 'actName')} placeholder="活动名称"></Input>
                            </div>
                        </div>
                        <Button onClick={this.getListData.bind(this)}>搜索</Button>
                        <span className="addText" onClick={this.addActivity.bind(this)}>添加</span>
                    </div>
                    <Table columns={columnsOfLive}
                        dataSource={activityList}
                        pagination={false}
                        onChange={this.handleTableChange}
                        rowKey={(row, index) => 'playList' + row.playId + '-' + index}
                    />
                    <Modal
                        destroyOnClose={true}
                        title={infoModal.isCircleInfo ? '指定公众圈' : '指定主播'}
                        onCancel={this.modalCancel.bind(this, 'info')}
                        visible={infoModal.show}
                        width={500}
                        footer={
                            [
                                <Button key="submit" type="primary" onClick={this.modalCancel.bind(this, 'info')}>关闭</Button>,
                            ]
                        }
                    >
                        <div className="modalPane">
                            <Table columns={
                                infoModal.isCircleInfo ? columnsOfCircle : columnsOfUser
                            }
                                dataSource={infoModal.infoList}
                                pagination={false}
                                rowKey={(row,index) => 'circleUserList' + row.infoId+'-'+index}
                            >
                            </Table>
                            {
                                infoModal.isCircleInfo && <div className="cityCircle">
                                    <div className="checkBox">
                                        {
                                            infoModal.cityCircle == 1 && <div className="innerBox"></div>
                                        }
                                    </div> 城市公众圈
                               </div>
                            }
                        </div>
                    </Modal>
                    <Modal
                        destroyOnClose={true}
                        title={addOrEditModal.isAdd ? '添加' : '编辑'}
                        onCancel={this.modalCancel.bind(this, 'addOrEdit')}
                        visible={addOrEditModal.show}
                        width={800}
                        footer={
                            [
                                <Button key="submit" type="primary" onClick={this.addOrEdit.bind(this, 'addOrEdit')}>保存</Button>,
                                <Button key="back" type="danger" onClick={this.modalCancel.bind(this, 'addOrEdit')}>取消</Button>,
                            ]
                        }
                    >
                        <div className="addOrEditPane">
                            <div className="formItem">
                                <div className="formTitle">*活动类型</div>
                                <div className="rightFormBlock">
                                    <Select className="selectBlock" defaultValue={addOrEditModal.playType} onChange={this.onSelectChange.bind(this, 'playType')}>
                                        <Option value="4">寻宝</Option>
                                        <Option value="1">抽奖</Option>
                                        <Option value="3">礼包</Option>
                                        <Option value="100">组局</Option>
                                    </Select>
                                </div>
                            </div>
                            <div className="formItem">
                                <div className="formTitle">*活动Id</div>
                                <div className="rightFormBlock">
                                    <Input className="inputBlock" onChange={this.InputItemChange.bind(this, 'playId')} placeholder="活动Id" defaultValue={addOrEditModal.playId}></Input>
                                    {hasClicked && addOrEditModal.playId == '' && <div className="formItemError">请填写活动Id</div>}
                                </div>
                            </div>
                            <div className="formItem">
                                <div className="formTitle">*活动广告图</div>
                                <div className="rightFormBlock">
                                    <div id="chooseActivityPic" className="chooseActivityPic"></div>
                                    {hasClicked && !addOrEditModal.image && <div className="formItemError">请选择活动广告图</div>}
                                </div>
                            </div>
                            <div className="formItem">
                                <div className="formTitle">*推广模块</div>
                                <div className="rightFormBlock">
                                    <Select className="selectBlock" defaultValue={addOrEditModal.liveType} onChange={this.onSelectChange.bind(this, 'liveType')}>
                                        <Option value="2">秀客直播</Option>
                                        <Option value="1">公众圈直播</Option>
                                    </Select>
                                </div>
                            </div>
                            <div className="formItem">
                                <div className="formTitle">*推广范围</div>
                                <div className="rightFormBlock">
                                    <Select className="selectBlock" defaultValue={addOrEditModal.targetType} onChange={this.onSelectChange.bind(this, 'targetType')}>
                                        {addOrEditModal.liveType == 2 && <Option value="0">所有</Option>}
                                        <Option value="1">指定公众圈</Option>
                                        {addOrEditModal.liveType == 2 && <Option value="2">指定主播</Option>}
                                    </Select>
                                </div>
                            </div>
                            {
                                addOrEditModal.targetType != 0 &&
                                <div className="formItem">
                                    <div className="formTitle">*{addOrEditModal.targetType == 1 ? '公众圈Id' : '用户Id'}</div>
                                    <div className="rightFormBlock">
                                        <Input className="inputBlock" onChange={this.InputItemChange.bind(this, 'targetValue')} placeholder={addOrEditModal.targetType == 1 ? '全部城市公众圈,可直接勾选，无需填写Id' : '用户Id填写，用逗号隔开'} defaultValue={addOrEditModal.targetValue}></Input>
                                        {hasClicked &&addOrEditModal.targetType == 1 &&addOrEditModal.targetValue == ''&& addOrEditModal.cityCircle != 1 && <div className="formItemError">请填写公众圈Id</div>}
                                        {hasClicked &&addOrEditModal.targetType == 2 &&addOrEditModal.targetValue == ''&& <div className="formItemError">请填写用户Id</div>}
                                    </div>
                                </div>
                            }
                            {
                                addOrEditModal.targetType == 1 &&
                                <div className="formItem">
                                    <div className="formTitle">城市公众圈</div>
                                    <div className="rightFormBlock">
                                        <div className="checkBox" onClick={this.chooseCityCircle.bind(this)}>{
                                            addOrEditModal.cityCircle == 1 &&
                                            <div className="innerBox"></div>
                                        }
                                        </div>
                                    </div>
                                </div>
                            }
                            <div className="formItem">
                                <div className="formTitle">*活动时间</div>
                                <div className="rightFormBlock">
                                    <RangePicker
                                        className="rangePicker"
                                        showTime={{ format: 'HH:mm:ss' }}
                                        format="YYYY-MM-DD HH:mm:ss"
                                        defaultValue={addOrEditModal.defaultMoment ? addOrEditModal.defaultMoment :[]}
                                        onChange={this.onDateChange.bind(this)}
                                    ></RangePicker>
                                    {hasClicked && !addOrEditModal.startTime && <div className="formItemError">请选择活动时间</div>}
                                </div>
                            </div>
                        </div>
                    </Modal>
                </Fragment>
            </ConfigProvider>
        )
    }
}

export default LiveActivity;